import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import './LoginPage.css';

const LoginPage = ({ handleLogin }) => {
  const errorMessage = (error) => {
    console.log(error);
  };

  return (
    <div className="login-page">
      <img src="/icons/OptiStudios.jpg" alt="OptiStudios" style={{ width: '450px', height: '300px' }} />
      <div className="login-page__description">
                    <p>With AI reshaping the job market, having a skill you control—immune to AI and capable of generating consistent income—is no longer optional. It’s <b>essential</b>.</p>

                    <p><b>Use OPTISTUDIOS.COM</b>, Trade Smarter. Let’s begin—together.</p>                       
      </div>
      <div className="google-login-container">
        <GoogleLogin onSuccess={handleLogin} onError={errorMessage} />
      </div>
      <br />
      <div className="video-section">
        <div className="video-container">
          <iframe
            width="672"
            height="378"
            src="https://www.youtube.com/embed/E79seWbsZds"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;